module.exports = __webpack_public_path__ + "img/sick-icon-1.0a5959b7.png";